module.exports = __webpack_public_path__ + "img/zalo.af529a80.png";